import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Tabs, Tab, Box } from '@mui/material';
import Users from './components/Users';
import Habits from './components/Habits';
import Track from './components/Track';
import Auth from './components/Auth';
import Points from './components/Points';
import PointReference from './components/PointReference';
import './styles.css'; // Import the styles
import { UsersProvider } from './contexts/UsersContext';
import { HabitsProvider } from './contexts/HabitsContext';
import { HabitObservationsProvider } from './contexts/HabitObservationsContext';

export default function App() {
  const SECTIONS = {
    TRACK: 0,
    SETUP: 1,
  };
  const apiUrl = window.env.API_URL;
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [isAdmin, setIsAdmin] = useState(null);
  const [currentTab, setCurrentTab] = useState(SECTIONS.TRACK);

  useEffect(() => {
    const fullAuthUrl = `${apiUrl}/is-authenticated`;
    axios
      .get(fullAuthUrl)
      .then((response) => {
        console.log('Received from auth call:', response.data);
        const responseData = response.data;
        let checkedIsAuthenticated = responseData.isAuthenticated;
        checkedIsAuthenticated =
          checkedIsAuthenticated &&
          (responseData.role === 'user' || responseData.role === 'admin');
        setIsAuthenticated(checkedIsAuthenticated);

        if (checkedIsAuthenticated && responseData.role === 'admin') {
          setIsAdmin(true);
        }
      })
      .catch((error) => {
        console.log('Error getting auth', error);
        setIsAuthenticated(false);
      });
  }, []);

  const handleChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  return (
    <UsersProvider apiUrl={apiUrl}>
      <HabitsProvider apiUrl={apiUrl}>
        <HabitObservationsProvider apiUrl={apiUrl}>
          <Box className="app-container">
            <Tabs
              value={currentTab}
              onChange={handleChange}
              centered
              className="custom-tabs"
            >
              <Tab label="Track" className="custom-tab" />
              <Tab label="Setup" className="custom-tab" />
            </Tabs>
            <Box className="content-area">
              {currentTab === SECTIONS.TRACK && (
                <>
                  <Track apiUrl={apiUrl} isAdmin={isAdmin} />
                  <Points apiUrl={apiUrl} isAdmin={isAdmin} />
                  <PointReference isAuthenticated={isAuthenticated} />
                </>
              )}
              {currentTab === SECTIONS.SETUP && (
                <>
                  <Auth isAdmin={isAdmin} isAuthenticated={isAuthenticated} />
                  <Users apiUrl={apiUrl} isAdmin={isAdmin} />
                  <Habits apiUrl={apiUrl} isAdmin={isAdmin} />
                </>
              )}
            </Box>
          </Box>
        </HabitObservationsProvider>
      </HabitsProvider>
    </UsersProvider>
  );
}
